import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, Renderer2, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { PerNgPlatformService } from '@pershing/per-ng-platform-service';
import { PageService } from '../../services/page.service';
import { PortalService } from '../../services/portal.service';
import { loadRemoteModule } from '@angular-architects/module-federation';


@Component({
  selector: 'app-page-item',
  templateUrl: './page-item.component.html'
})
export class PageItemComponent implements AfterViewInit {

  @Input()
  name: any;

  @Input()
  type: any;

  @Input()
  input: any;

  @ViewChild('content', { read: ElementRef })
  content!: ElementRef;

  @ViewChild('mfecomponent', { read: ViewContainerRef, static: true })
  mfeComponent!: ViewContainerRef;

  component: any;

  private _appSettings: any;

  constructor(private _renderer: Renderer2,
    private _pageService: PageService,
    private _portalService: PortalService,
    private _platformService: PerNgPlatformService,
    private _ref: ChangeDetectorRef) {

    // consume app settings from platform service
    this._appSettings = this._platformService.getAppSettings();
  }

  ngAfterViewInit(): void {
    this.processItem();
  }


  // dynamically add element or component to the panel
  // TODO: accept parameters for components
  processItem(): void {

    if (this.name && this.type) {

      // process component
      if (this.type === "component") {
        this.component = this._pageService.getComponentFromMap(this.name);
        return;
      }
      else if (this.type === "mfe") {
        // process mfes
        const elementConfig = this._portalService.getElementConfig(this.name);
        if (elementConfig) {
          const url = elementConfig['url'];
          console.log(this.input);

          const el = this._renderer.createElement(this.name);
          for (let attr in this.input) {
            this.handleAttribute(el, attr);
          }
          this.handleMfe(el, elementConfig);
        }
      }
    }
  }

  handleAttribute(el: any, attr: string) {
    if (attr[0] === '@') {
      // Doesn't seem to be a real NXI use case currently, but
      // this is written to read 'dynamic' input that rely on value from appSetting.
      // e.g. if configured {... input {@account, "param1": "value1" }
      // This code will try to take value of account from appSettings.
      const indexStr = attr.substring(1);
      if (this._appSettings[indexStr])
        this._renderer.setAttribute(el, attr, this._appSettings[indexStr]);
    } else {
      this._renderer.setAttribute(el, attr, this.input[attr]); //will turn the attribute name into all lowercase to comply with HTML rules
    }
  }

  async handleMfe(el: any, elementConfig: any): Promise<void> {
    // load module and component if it exists
    const url = elementConfig['url'];
    const componentName = elementConfig['componentName'];

    const mRef = await loadRemoteModule({
      type: elementConfig['type'],
      remoteEntry: url,
      exposedModule: elementConfig['exposedModule']
    })
      .then(m => m[componentName])
      .catch(err => console.error(`error loading ${elementConfig['exposedModule']}:`, err));

    if (componentName) {
      // process individual component
      this.mfeComponent.clear();
      this.mfeComponent.createComponent(mRef);
      this._ref.markForCheck();
    }
    else {
      // processing element
      this._renderer.appendChild(this.content.nativeElement, el);
    }
  }


}


